import React, { useEffect, useState } from 'react'
import PageHeader from '../../components/PageHeader'
import { notiflixLoaderEnd, notiflixLoaderStart } from '../../components/ui/notification';
import { actionNotifier } from '../../components/ui/toast';
import { getMasterData } from '../AddComplain/api';
import { getVcData } from './api';
import { changeTzToNormalDefault } from '../../shared/dateFunction';

const VcReportAdmin = () => {
    const [district, setDistrict] = useState([]);
    const [vcBlock, setVcBlock] = useState([]);
    const [vcNode, setVcNode] = useState([]);
    const [rows, setRows] = useState([]);

    let [filter, setFilter] = useState({
        district: '',
        vcBlock: '',
        vcNode: '',
        date: ''
    });

    const getDistrict = async () => {
        notiflixLoaderStart();
        try {
            let dataDistrict = await getMasterData("?type=DISTRICT");
            setDistrict(dataDistrict);
        } catch (error) {
            console.error("Error fetching districts:", error);
            actionNotifier.error("An error occurred while fetching districts.");
        } finally {
            notiflixLoaderEnd();
        }
    };

    const handleFilterChange = async (e) => {
        const { name, value } = e.target;
        setFilter(prevFilter => ({
            ...prevFilter,
            [name]: value,
        }));

        if (name === 'district') {
            notiflixLoaderStart();
            try {
                let dataBlock = await getMasterData(
                    `?type=VC_NODE_BLOCK&districtName=${value}`
                );
                setVcBlock(dataBlock);
            } catch (error) {
                console.error("Error fetching blocks:", error);
                actionNotifier.error("An error occurred while fetching blocks.");
            } finally {
                notiflixLoaderEnd();
            }
        }

        if (name === 'vcBlock') {
            notiflixLoaderStart();
            try {
                let dataNode = await getMasterData(
                    `?type=VC_NODE&blockName=${value}`
                );
                setVcNode(dataNode);
            } catch (error) {
                console.error("Error fetching schools:", error);
                actionNotifier.error("An error occurred while fetching schools.");
            } finally {
                notiflixLoaderEnd();
            }
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            if (filter.vcNode, filter.date) {
                let data = {
                    complexId: filter.vcNode,
                    date: filter.date
                }
                notiflixLoaderStart();
                try {
                    let res = await getVcData(data);
                    if (res.status) {
                        setRows(res.data)
                    } else {
                        actionNotifier.error(res.message);
                    }
                } catch (error) {
                    console.error("Error:", error);
                    actionNotifier.error("An error occurred while submitting.");
                } finally {
                    notiflixLoaderEnd();
                }
            } else {
                console.log("Something Went Wrong!! Please refresh the page");
            }
        };
        fetchData();
    }, [filter]);

    useEffect(() => {
        getDistrict();
    }, []);

    return (
        <div className="container-fluid ccc-page">
            <PageHeader HeaderText="View VC Report" Breadcrumb={[]} />
            <div className="ccc-filter-card">
                <h5 className="ccc-filter-heading">Filters</h5>
                <div className="row">
                    <div className="col-md-6 mb-2">
                        <label className="ccc-filter-label">District</label>
                        <select
                            className="form-control"
                            name="district"
                            value={filter?.district}
                            onChange={(e) => handleFilterChange(e)}
                        >
                            <option value="%" selected>
                                All District
                            </option>
                            {district?.map((s) => (
                                <option value={s.districtName} selected>
                                    {s.districtName}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-6 mb-2">
                        <label className="ccc-filter-label">Block</label>
                        <select
                            className="form-control"
                            name="vcBlock"
                            value={filter?.vcBlock}
                            onChange={(e) => handleFilterChange(e)}
                        >
                            <option value="%" selected>
                                All Block
                            </option>
                            {vcBlock?.map((s) => (
                                <option value={s.block} selected>
                                    {s.block}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-6 mb-2">
                        <label className="ccc-filter-label">Complex</label>
                        <select
                            className="form-control"
                            name="vcNode"
                            value={filter?.vcNode}
                            onChange={(e) => handleFilterChange(e)}
                        >
                            <option value="%" selected>
                                All Complex
                            </option>
                            {vcNode?.map((s) => (
                                <option value={s.id} selected>
                                    {s.complexName}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-6 mb-2">
                        <label className="ccc-filter-label">Date</label>
                        <input
                            type='date'
                            className='form-control'
                            name="date"
                            value={filter.date}
                            onChange={(e) => handleFilterChange(e)} />
                    </div>
                </div>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                {
                    rows?.length > 0 && rows?.map((a, index) => {
                        return <div key={index} className='card' style={{ width: '200px', height: '250px', padding: '5px', margin: '5px' }} >
                            <a href={`${process.env.REACT_APP_IMAGE_URL}${a.imagePath}`} target='_blank'>
                                <img src={`${process.env.REACT_APP_IMAGE_URL}${a.imagePath}`} alt='pp' style={{ width: '200px', height: '200px', padding: '5px', objectFit: 'cover', margin: 'auto' }} />
                                <span>Photo Taken Date & Time : - {changeTzToNormalDefault(a?.createdAt).date + "," + changeTzToNormalDefault(a?.createdAt).time}</span>
                            </a>
                        </div>
                    })
                }
            </div>
        </div>
    )
}

export default VcReportAdmin
